// Author XXL
// Date 2021-03-19 18:16:53

class SithMesInventoryStatus {
constructor({
        id = null,
        code = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryStatus();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.inventory.sithMesInventoryStatus.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryStatus.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStatus.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.inventory.sithMesInventoryStatus.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.inventory.sithMesInventoryStatus.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.inventory.sithMesInventoryStatus.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.sith.inventory.sithMesInventoryStatus.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStatus.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryStatus, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
